import { createState, Downgraded, State, useState } from '@hookstate/core';
import { AxiosResponse } from 'axios';
import { IAuthState, IVerifyToken } from '../interfaces/app.interface';
import { authService } from '../services/auth.service';
import { storageService } from '../_helpers';

const initAuthState: IAuthState = {
  currentUser: null,
  outstandingBookings: []
}
const authState = createState(initAuthState);

const wrapAuthState = (s: State<IAuthState>) => {
  const getOutstandingBookings = () => {
    return authService.getOutstandingBookings().then(res => {
      s.outstandingBookings.set(res.data)
      return res
    })
  }

  const loginCallback = (res: AxiosResponse) => {
    s.currentUser.set(res.data)
    storageService.setAccessToken(res.data.access_token)
    storageService.setRefreshToken(res.data.refresh_token)
    getOutstandingBookings()
  }

  return ({
    /**
     * Get state
     * @returns
     */
    get: () => s.value,

    /**
     * Set state
     * @param state
     * @returns
     */
    set: (state: IAuthState) => s.set({ ...s.value, ...state }),

    /**
     * Set a state field
     * @param key
     * @param value
     * @returns
     */
    setValue: (key: keyof IAuthState, value: any) => s.set({ ...s.value, [key]: value }),

    setAvatar: (avatar: string) => {
      s.currentUser.set(p => {
        if (p) {
          return { ...p, pic: avatar }
        } else {
          return p
        }
      })
    },

    get isLoggedIn(): boolean { return storageService.getAccessToken() || !!s.value.currentUser },

    login: (username: string, password: string) => {
      return authService.login(username, password).then(res => {
        if (res.data.access_token) {
          loginCallback(res)
        }
        return res
      })
    },

    loginFB: (tokenFB: string) => {
      return authService.loginFB(tokenFB).then(res => {
        loginCallback(res)
        return res
      })
    },

    loginG: (tokenG: string) => {
      return authService.loginG(tokenG).then(res => {
        loginCallback(res)
        return res
      })
    },

    logout: () => {
      return authService.logout().then(res => {
        authLogout()
        return res
      })
    },

    getMe: () => {
      return authService.me().then(res => {
        s.currentUser.set(res.data)
        return res
      })
    },

    verifyToken: (data: IVerifyToken) => {
      return authService.verifyToken(data)
        .then(res => {
          s.currentUser.set(res.data)
          storageService.setAccessToken(res.data.access_token)
          getOutstandingBookings()
          return res
        })
    },

    getOutstandingBookings
  })
};

// It can be used inside of a component
export const useAuthState = () => wrapAuthState(useState(authState).attach(Downgraded));
export const accessAuthState = () => wrapAuthState(authState);
export const authLogout = () => {
  authState.currentUser.set(null)
  authState.outstandingBookings.set([])
  storageService.clearStorage()
}

const token = storageService.getAccessToken();

if (token) {
  authService.me().then(res => {
    authState.currentUser.set(res.data)
    return 1
  }).then(r => {
    authService.getOutstandingBookings().then(res => {
      authState.outstandingBookings.set(res.data)
    })
  })
}
